import cloneDeep from 'lodash/cloneDeep';
import React, { useMemo } from 'react';

import LandingPageMembershipTabs from '@/app/components/LandingPage/LandingPageMembershipTabs';
import japaneseMembershipTabsOverrides from '@/app/components/LandingPage/LandingPageMembershipTabs/_data/japaneseLandingPageMembershipTabDataOverrides';
import getLandingPageMembershipTabData from '@/app/components/LandingPage/LandingPageMembershipTabs/_utils/getLandingPageMembershipTabData';
import useJapaneseRegionalSite from '@/app/experiments/useJapaneseRegionalSite';
import useTrustedAdvisorRollout from '@/app/hooks/useTrustedAdvisorRollout';

export default function PopMembershipTabs() {
  const isJapaneseRegionalSite = useJapaneseRegionalSite();
  // TODO: GROW-2946 Clean up trusted advisor rollout
  const isTrustedAdvisorEnabled = useTrustedAdvisorRollout();

  const tabData = useMemo(() => {
    const baseTabData = getLandingPageMembershipTabData(
      isTrustedAdvisorEnabled,
    );
    return isJapaneseRegionalSite
      ? cloneDeep(baseTabData).map((tab) => {
          return {
            ...tab,
            tabPanel: {
              ...tab.tabPanel,
              ...japaneseMembershipTabsOverrides[tab.id]?.tabPanel,
            },
          };
        })
      : baseTabData;
  }, [isJapaneseRegionalSite, isTrustedAdvisorEnabled]);

  return <LandingPageMembershipTabs tabsData={tabData} />;
}
